import type { Time } from "./Time";

export class EmptyTime implements Time {
  get countMarks(): number {
    return -1;
  }

  get countMeasures(): number {
    return -1;
  }

  get timeTotal(): number {
    return -1;
  }

  get timeAverage(): number {
    return -1;
  }

  get timeSum(): number {
    return -1;
  }

  measure(): number | void {
    return;
  }

  reset(): void {
    return;
  }

  /*                                                         */
  measureOnce(startTime: number, endTime?: number): void {
    return;
  }

  get measurePerfEntries(): PerformanceEntryList {
    return [];
  }

  get navigationStart(): number {
    return 0;
  }
}
